document.addEventListener('DOMContentLoaded', function () {

///Announcement bar: dismiss only for current view (comes back on refresh)
(function () {
  // The theme stores a 30-day "dismiss" cookie when the close button is
  // clicked, which kept the bar hidden permanently. Clear it on every load
  // (runs before the announcement section's init reads it) so a page refresh
  // always shows the bar again. The close button still hides it for the
  // current view via z__jsAnnouncementBar.js (removes announcement-bar--visible).
  document.cookie =
    'announcement-bar=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';

  // Safety net: if the bar still got hidden by the cookie before this ran,
  // force it back to the visible state on load (does not affect a later
  // in-session close, which runs after this).
  function forceShowAnnouncement() {
    var body = document.body;
    if (!body) return;
    body.classList.remove('announcement-bar--hidden');
    body.classList.add('announcement-bar--visible');
  }

  forceShowAnnouncement();
})();
///End Announcement bar dismiss reset

///Home page add aria-label on 'Shop now' links
document.querySelectorAll('a.button.button--secondary').forEach(link => {
  const linkText = link.textContent.trim();

  // Nearest parent ke andar h2 dhoondo
  let parent = link.parentElement;
  let heading = null;

  while (parent && !heading) {
    heading = parent.querySelector('h2');
    parent = parent.parentElement;
  }

  if (heading) {
    const headingText = heading.textContent.trim();
    link.setAttribute(
      'aria-label',
      `${linkText}, ${headingText}`
    );
  }
});
///End Home page add aria-label on 'Shop now' links

///Home page project + Tutorial
document.querySelectorAll('a.button.button--link-style').forEach(link => {
  const linkText = link.textContent.trim();

  // Find nearest h2 on Parent containers
  let parent = link.parentElement;
  let heading = null;

  while (parent && !heading) {
    heading = parent.querySelector('h2');
    parent = parent.parentElement;
  }

  if (heading) {
    const headingText = heading.textContent.trim();

    link.setAttribute(
      'aria-label',
      `${linkText}, ${headingText}`
    );
  }
});
///End Home page project + Tutorial

// ///Sign up aria-label
// const containers = document.querySelectorAll(
//   '.newsletter__wrapper.column.one-whole, div#shopify-section-0be344fb-cc27-40d8-9777-a5ea0aa0630c'
// );

// containers.forEach(container => {
//   const heading = container.querySelector('h2');

//   if (!heading) return;

//   container
//     .querySelectorAll('button.button.button--primary.is-within-form')
//     .forEach(button => {
//       const buttonText = button.textContent.trim();

//       button.setAttribute(
//         'aria-label',
//         `${buttonText}, After signing up the page will refresh`
//       );
//     });
// });

// ///End Sign up aria-label

// Third-party warning
(function () {
  "use strict";

  var WARNING_TEXT =
    "Redirecting to a third-party website (opens in a new tab).";

  // Links that should be completely ignored
  var EXCLUDED_ORIGINS = [
    "https://kitchenandcompany.myshopify.com"
  ];

  function decodeHtmlEntities(text) {
    if (!text) return "";

    var textarea = document.createElement("textarea");
    var decoded = text;

    for (var i = 0; i < 3; i++) {
      textarea.innerHTML = decoded;

      if (textarea.value === decoded) break;

      decoded = textarea.value;
    }

    return decoded;
  }

  function cleanLabel(text) {
    if (!text) return "";

    text = decodeHtmlEntities(text);

    return text
      .replace(/\(opens?\s+in\s+a\s+new\s+(window|tab)\)/gi, "")
      .replace(/opens?\s+in\s+a\s+new\s+(window|tab)/gi, "")
      .replace(
        /,\s*Redirecting to a third-party website\s*\(opens in a new tab\)\.?/gi,
        ""
      )
      .replace(
        /Redirecting to a third-party website\s*\(opens in a new tab\)\.?/gi,
        ""
      )
      .replace(/\s+/g, " ")
      .trim();
  }

  function getIconLabel(link) {
    var classes = (link.className || "").toLowerCase();
    var href = (link.href || "").toLowerCase();

    var platforms = [
      ["facebook", "Follow us on Facebook"],
      ["instagram", "Follow us on Instagram"],
      ["twitter", "Follow us on X"],
      ["x.com", "Follow us on X"],
      ["youtube", "Visit our YouTube channel"],
      ["linkedin", "Connect with us on LinkedIn"],
      ["pinterest", "Follow us on Pinterest"],
      ["tiktok", "Follow us on TikTok"],
      ["threads", "Follow us on Threads"],
      ["snapchat", "Follow us on Snapchat"],
      ["whatsapp", "Contact us on WhatsApp"],
      ["vimeo", "Visit our Vimeo page"],
      ["flickr", "Visit our Flickr page"]
    ];

    for (var i = 0; i < platforms.length; i++) {
      if (
        classes.indexOf(platforms[i][0]) !== -1 ||
        href.indexOf(platforms[i][0]) !== -1
      ) {
        return platforms[i][1];
      }
    }

    return "External link";
  }

  function updateExternalLinks() {
    document.querySelectorAll("a[href]").forEach(function (link) {
      var href = link.getAttribute("href");

      if (!href) return;

      if (
        href.indexOf("mailto:") === 0 ||
        href.indexOf("tel:") === 0 ||
        href.indexOf("javascript:") === 0 ||
        href.indexOf("#") === 0
      ) {
        return;
      }

      var url;

      try {
        url = new URL(href, window.location.href);
      } catch (e) {
        return;
      }

      // Same-domain links are ignored
  var currentHostname = window.location.hostname.replace(/^www\./, "");
var linkHostname = url.hostname.replace(/^www\./, "");

if (linkHostname === currentHostname) {
  return;
}

      // Excluded external domains are completely ignored
      if (EXCLUDED_ORIGINS.indexOf(url.origin) !== -1) {
        return;
      }

      var existingAriaLabel =
        link.getAttribute("aria-label") || "";

      // If warning already exists, only remove title
      if (
        existingAriaLabel
          .toLowerCase()
          .indexOf(WARNING_TEXT.toLowerCase()) !== -1
      ) {
        if (link.hasAttribute("title")) {
          link.removeAttribute("title");
        }

        return;
      }

      var label = cleanLabel(
        link.getAttribute("title") ||
        existingAriaLabel ||
        link.textContent ||
        ""
      );

      if (!label) {
        label = getIconLabel(link);
      }

      link.setAttribute(
        "aria-label",
        label + ", " + WARNING_TEXT
      );

      // Remove title because aria-label is now available
      if (link.hasAttribute("title")) {
        link.removeAttribute("title");
      }

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    });

  }

  updateExternalLinks();
})();
// End Third-party warning

 ///embroidery-floss page view all link aria-label
document.querySelectorAll('a.button.button--primary.new-btn').forEach(link => {
  let closestH2 = null;

  document.querySelectorAll('h2').forEach(h2 => {
    // sirf woh h2 jo link se pehle DOM me ho
    if (h2.compareDocumentPosition(link) & Node.DOCUMENT_POSITION_FOLLOWING) {
      closestH2 = h2; // last matched = nearest above h2
    }
  });

  if (closestH2) {
    const linkText = link.textContent.trim();
    const h2Text = closestH2.textContent.trim();

    link.setAttribute('aria-label', `${linkText}, ${h2Text}`);
  }
});
///End embroidery-floss page view all link aria-label
 

///Embroidery-floss page link aria-label
const headings = document.querySelectorAll('h2.featured-collection__title.title');
const links = document.querySelectorAll('a.product-thumbnail__title');

links.forEach(link => {
  let matchedH2 = null;

  headings.forEach(h2 => {
    // check if h2 comes BEFORE the link in DOM
    if (h2.compareDocumentPosition(link) & Node.DOCUMENT_POSITION_FOLLOWING) {
      matchedH2 = h2;
    }
  });

  if (matchedH2) {
    const linkText = link.textContent.trim();
    const h2Text = matchedH2.textContent.trim();

    link.setAttribute('aria-label', `${linkText}, ${h2Text}`);
  }
});
///End Embroidery-floss page link aria-label

///Product page kiriki press aria-label
if (document.body.matches('body.product')) {
  const h1 = document.querySelector('h1');

  if (h1) {
    const h1Text = h1.textContent.trim();

    document.querySelectorAll('p a').forEach(link => {
      const linkText = link.textContent.trim();

      if (linkText) {
        link.setAttribute('aria-label', `${linkText}, ${h1Text}`);
      }
    });
  }
}
///End Product page kiriki press aria-label

///Desktop menu click base
(function () {
  'use strict';

  var ITEM_SELECTOR = '.navbar-item.has-dropdown';

  function getTrigger(item) {
    return item.querySelector('a.navbar-link.header__link');
  }

  function getDropdown(item) {
    return item.querySelector('.navbar-dropdown');
  }

  function closeItem(item) {
    if (!item.classList.contains('is-active')) return;

    item.classList.remove('is-active');

    var trigger = getTrigger(item);
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    var dd = getDropdown(item);
    if (dd) {
      dd.setAttribute('aria-hidden', 'true');
    }
  }

  function openItem(item) {
    // close others first
    var openItems = document.querySelectorAll(ITEM_SELECTOR + '.is-active');
    for (var i = 0; i < openItems.length; i++) {
      if (openItems[i] !== item) {
        closeItem(openItems[i]);
      }
    }

    item.classList.add('is-active');

    var trigger = getTrigger(item);
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

    var dd = getDropdown(item);
    if (dd) {
      dd.setAttribute('aria-hidden', 'false');
    }
  }

  function toggleItem(item) {
    if (item.classList.contains('is-active')) {
      closeItem(item);
    } else {
      openItem(item);
    }
  }

  function setupItem(item) {
    var trigger = getTrigger(item);
    if (!trigger) return;

    // make it button-like (but keep href safe for SEO fallback)
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-expanded', 'false');

    var dd = getDropdown(item);
    if (dd) {
      dd.setAttribute('aria-hidden', 'true');
    }

    // =========================
    // MOUSE CLICK (REAL FLOW)
    // =========================
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      toggleItem(item);
    });

    // =========================
    // KEYBOARD (SYNC WITH MOUSE)
    // =========================
   // =========================
// KEYBOARD
// =========================
trigger.addEventListener('keydown', function (e) {
  var key = e.key;

  if (key === 'Enter' || key === ' ' || key === 'Spacebar') {

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    item.classList.remove('show-dropdown');
    toggleItem(item);

    return false;
  }

  if (key === 'Escape' || key === 'Esc') {

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    closeItem(item);
    trigger.focus();

    return false;
  }

}, true);
  }

  function init() {
    var items = document.querySelectorAll(ITEM_SELECTOR);

    for (var i = 0; i < items.length; i++) {
      setupItem(items[i]);
    }

    // click outside closes all
    document.addEventListener('click', function (e) {
      var openItems = document.querySelectorAll(ITEM_SELECTOR + '.is-active');

      for (var i = 0; i < openItems.length; i++) {
        if (!openItems[i].contains(e.target)) {
          closeItem(openItems[i]);
        }
      }
    });

    // ESC global close
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;

      var openItems = document.querySelectorAll(ITEM_SELECTOR + '.is-active');

      for (var i = 0; i < openItems.length; i++) {
        closeItem(openItems[i]);
      }
    });
  }

  init();
})();
///dropdown menu close after clicking
document.querySelectorAll('.navbar-item.has-dropdown.is-active')
  .forEach(function (item) {
    item.classList.remove('is-active');

    var trigger = item.querySelector('a.navbar-link.header__link');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    var dd = item.querySelector('.navbar-dropdown');
    if (dd) dd.setAttribute('aria-hidden', 'true');
  });
///End Desktop menu click base

///Blogs adding aria label
(function () {

  function addAriaLabels() {

    const container = document.querySelector(".container.article-content.has-padding-top.has-padding-bottom");

    if (!container) return false;

    const content = container.querySelector(".one-whole.column.content");

    if (!content) return false;

    const links = content.querySelectorAll("a");

    links.forEach(link => {

      if (link.hasAttribute("aria-label")) return;

      const text = link.textContent.trim();
      if (!text) return;

      link.setAttribute("aria-label", `Read more about, ${text}`);
    });

    return true;
  }

  function init() {

    let attempts = 0;

    const interval = setInterval(() => {

      attempts++;

      const done = addAriaLabels();

      if (done || attempts > 20) {
        clearInterval(interval);
      }

    }, 500);
  }

  init();

})();
///End Blogs aria label

// ///Blogs heading fixes
// (function () {

//   function convertHeadings() {

//     const container = document.querySelector(".container.article-content.has-padding-top.has-padding-bottom");
//     if (!container) return false;

//     const content = container.querySelector(".one-whole.column.content");
//     if (!content) return false;

//     const h3s = content.querySelectorAll("h3");

//     h3s.forEach(h3 => {

//       const h2 = document.createElement("h2");

//       // copy attributes (class, style, etc.)
//       Array.from(h3.attributes).forEach(attr => {
//         h2.setAttribute(attr.name, attr.value);
//       });

//       h2.innerHTML = h3.innerHTML;

//       h3.parentNode.replaceChild(h2, h3);
//     });

//     return true;
//   }

//   function init() {

//     let tries = 0;

//     const interval = setInterval(() => {

//       tries++;

//       const done = convertHeadings();

//       if (done || tries > 20) {
//         clearInterval(interval);
//       }

//     }, 500);
//   }

//   init();

// })();
// ///End Blogs heading fixes

//Blogs heading fixes
(function () {

  // H4 to H2
  const articleContent = document.querySelector(
    ".container.article-content .one-whole.column.content"
  );

  if (articleContent) {
    articleContent.querySelectorAll("h4").forEach(function (h4) {
      const h2 = document.createElement("h2");

      Array.from(h4.attributes).forEach(function (attr) {
        h2.setAttribute(attr.name, attr.value);
      });

      h2.innerHTML = h4.innerHTML;
      h4.parentNode.replaceChild(h2, h4);
    });
  }


  // H3 to H2
  const blogContainer = document.querySelector(
    ".container.article-content.has-padding-top.has-padding-bottom"
  );

  if (blogContainer) {
    const content = blogContainer.querySelector(
      ".one-whole.column.content"
    );

    if (content) {
      content.querySelectorAll("h3").forEach(function (h3) {
        const h2 = document.createElement("h2");

        Array.from(h3.attributes).forEach(function (attr) {
          h2.setAttribute(attr.name, attr.value);
        });

        h2.innerHTML = h3.innerHTML;
        h3.parentNode.replaceChild(h2, h3);
      });
    }
  }


  // Article H2 to H1
  const wrapper = document.querySelector(
    ".container .heading-wrapper--article"
  );

  if (wrapper) {
    const h2 = wrapper.querySelector(
      "h2.article__title.title"
    );

    if (h2) {
      const h1 = document.createElement("h1");

      Array.from(h2.attributes).forEach(function (attr) {
        h1.setAttribute(attr.name, attr.value);
      });

      h1.innerHTML = h2.innerHTML;
      h2.parentNode.replaceChild(h1, h2);
    }
  }

})();
//End Blogs heading fixes

///Mobile menu accessibility (remove checkbox+label, JS-driven accessible toggles)
(function () {
  'use strict';

  var idCounter = 0;

  // Replace an element with the same children/classes but a new tag (label -> div).
  // This keeps all `.submenu__label` styling while dropping the <label>/checkbox
  // pairing that screen readers announce as "checkbox, not checked".
  function retag(el, tagName) {
    var replacement = document.createElement(tagName);
    if (el.className) replacement.className = el.className;
    while (el.firstChild) replacement.appendChild(el.firstChild);
    el.parentNode.replaceChild(replacement, el);
    return replacement;
  }

  function processInput(input) {
    var levelEl = input.parentElement; // .mobile-menu__first-level / __second-level
    if (!levelEl) { input.remove(); return; }

    // The label that paired with this checkbox
    var label = document.querySelector('label[for="' + input.id + '"]');
    if (!label || label.parentElement !== levelEl) {
      var sib = input.nextElementSibling;
      label = (sib && sib.tagName === 'LABEL') ? sib : null;
    }

    // First submenu list inside this wrapper (null for plain links)
    var submenu = levelEl.querySelector('.mobile-menu__submenu');

    // Drop the checkbox entirely — this is what screen readers announced.
    input.remove();

    // Turn the <label> into a <div> so its styling stays but the
    // label/checkbox semantics are gone.
    var row = label ? retag(label, 'div') : levelEl;

    var anchor = row.querySelector('a.mobile-menu-link') || row.querySelector('a');
    if (!anchor) return;

    if (!submenu) {
      // No dropdown (e.g. "LAST CHANCE") — leave it as a normal link.
      return;
    }

    // Real expand/collapse toggle.
    anchor.removeAttribute('href');
    anchor.setAttribute('role', 'button');
    anchor.setAttribute('tabindex', '0');

    if (!submenu.id) submenu.id = 'mobile-submenu-region-' + (idCounter++);
    anchor.setAttribute('aria-controls', submenu.id);
    anchor.setAttribute('aria-expanded', 'false'); // closed by default

    function toggle() {
      var open = levelEl.classList.toggle('is-open');
      anchor.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    // Mouse / touch: whole row (link + arrow hit-area) toggles.
    row.addEventListener('click', function (e) {
      e.preventDefault();
      toggle();
    });

    // Keyboard: Enter / Space toggle.
    anchor.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'Enter' || k === ' ' || k === 'Spacebar') {
        e.preventDefault();
        toggle();
      }
    });
  }

  function processAll() {
    var inputs = document.querySelectorAll('.mobile-menu .submenu__input');
    for (var i = 0; i < inputs.length; i++) {
      processInput(inputs[i]);
    }
    return inputs.length > 0;
  }

  function init() {
    processAll();

    // Safety net: re-run if the menu (or a sticky clone) is injected later.
    if (typeof MutationObserver !== 'undefined') {
      var scheduled = false;
      var observer = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        setTimeout(function () {
          scheduled = false;
          processAll();
        }, 100);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  init();

})();
///End Mobile menu accessibility

/// Mobile submenu aria-hidden trigger values
function updateMobileMenuAria() {
  const toggleBtn = document.querySelector(
    '.mobile-menu__toggle-button.mobile-toggle__position--left'
  );
  const mobileMenu = document.querySelector('.mobile-menu');

  if (!toggleBtn || !mobileMenu) return;

  const isOpen =
    toggleBtn.getAttribute('data-show-mobile-menu') === 'true';

  mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

  console.log('Menu Open:', isOpen);
}

document.addEventListener('click', (e) => {
  if (e.target.closest('.mobile-menu__toggle-button')) {
    setTimeout(updateMobileMenuAria, 50);
  }
});
/// End Mobile submenu aria-hidden trigger values

/// Mobile menu close button trigger focus
(function () {
  const toggleSelector =
    '.mobile-menu__toggle-button.mobile-toggle__position--left';

  const closeSelector = '.close-mb-btn';
  const menuSelector = '.mobile-menu';

  function isOpen() {
    const toggleBtn = document.querySelector(toggleSelector);
    return toggleBtn?.getAttribute('data-show-mobile-menu') === 'true';
  }

  function focusCloseBtn() {
    const closeBtn = document.querySelector(closeSelector);

    if (closeBtn) {
      closeBtn.focus();
      console.log('Focus moved to Close Button');
    }
  }

  function focusToggleBtn() {
    const toggleBtn = document.querySelector(toggleSelector);

    if (toggleBtn) {
      toggleBtn.focus();
      console.log('Focus returned to Menu Button');
    }
  }

  // OPEN MENU → Focus Close Button
  document.addEventListener('click', function (e) {
    if (!e.target.closest(toggleSelector)) return;

    setTimeout(() => {
      if (isOpen()) {
        focusCloseBtn();
      }
    }, 300);
  });

  // CLOSE MENU → Focus Menu Button
  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest(closeSelector);

    if (!closeBtn) return;

    e.preventDefault();

    setTimeout(() => {
      const toggleBtn = document.querySelector(toggleSelector);
      const mobileMenu = document.querySelector(menuSelector);
      const icon = document.querySelector('.mobile-menu__toggle-icon');

      // Force close state
      toggleBtn?.setAttribute('data-show-mobile-menu', 'false');
      icon?.classList.remove('is-active');

      // Menu hidden for accessibility
      mobileMenu?.setAttribute('aria-hidden', 'true');

      // Return focus to menu button
      focusToggleBtn();
    }, 500);
  });
})();
/// End Mobile menu close button trigger focus

///Flicky slide buttons aria-label
(function () {

  function updateFlickityAriaLabels() {
    document.querySelectorAll('.flickity-prev-next-button').forEach(function (btn) {

      if (btn.classList.contains('previous')) {
        btn.setAttribute('aria-label', 'Previous slide');
      }

      if (btn.classList.contains('next')) {
        btn.setAttribute('aria-label', 'Next slide');
      }

    });
  }

  // Initial load
  updateFlickityAriaLabels();

  // Handle dynamically added sliders/buttons
  const observer = new MutationObserver(function () {
    updateFlickityAriaLabels();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
///End Flicky slide buttons aria-label

///Search popup: return focus to the search trigger on close / Escape
(function () {
  var pendingTrigger = null;    // trigger the user just activated
  var lastSearchTrigger = null; // trigger that opened the current search popup
  var searchOpen = false;

  function firstVisibleTrigger() {
    var list = document.querySelectorAll('[data-show-search-trigger]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].offsetParent !== null) return list[i]; // visible one
    }
    return list[0] || null;
  }

  // Remember which search trigger was activated (works for mouse + keyboard).
  function rememberTrigger(e) {
    var t = e.target.closest && e.target.closest('[data-show-search-trigger]');
    if (t) pendingTrigger = t;
  }
  document.addEventListener('click', rememberTrigger, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') rememberTrigger(e);
  }, true);

  function bind() {
    if (!window.jQuery) return false;
    var $ = window.jQuery;

    // After any Fancybox opens, check whether it is the SEARCH popup
    // (scoped via its .js-search-popup class so quick-shop etc. are ignored).
    $(document).on('afterShow.fb', function () {
      if (document.querySelector('.fancybox-content.js-search-popup')) {
        searchOpen = true;
        if (!lastSearchTrigger) {
          lastSearchTrigger = pendingTrigger || firstVisibleTrigger();
        }
      }
      pendingTrigger = null;
    });

    // On close (close button OR Escape — Fancybox closes on both),
    // return focus to the trigger that opened the search popup.
    $(document).on('afterClose.fb', function () {
      if (!searchOpen) return;
      searchOpen = false;
      var target = lastSearchTrigger || firstVisibleTrigger();
      lastSearchTrigger = null;
      if (target) {
        setTimeout(function () {
          try { target.focus(); } catch (err) {}
        }, 50);
      }
    });

    return true;
  }

  function retry() {
    var n = 0;
    var t = setInterval(function () {
      n++;
      if (bind() || n > 25) clearInterval(t);
    }, 200);
  }

  if (!bind()) {
    retry();
  }
})();
///End Search popup focus return

///Mini cart: close only via the cart icon / close button (not clicks inside)
(function () {
  // The mini cart is rendered INSIDE the [data-ajax-cart-trigger] wrapper, and
  // the theme delegates a click->toggle on that selector, so a click anywhere
  // inside the open cart was toggling it shut. Replace that handler with one
  // that ignores clicks inside the cart content (except on close controls).
  function applyFix() {
    if (!window.jQuery) return false;
    var $ = window.jQuery;

    // Only the mini-cart dropdown layout has this issue.
    if (!document.querySelector('.ajax-cart--mini-cart')) return false;
    if (!document.querySelector('[data-ajax-cart-trigger]')) return false;

    // Remove the theme's toggle handler (delegated with this exact selector)
    // and install the corrected one.
    $(document).off('click', '[data-ajax-cart-trigger]');
    $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
      var insideCart = e.target.closest('[data-ajax-cart-content]');
      var onClose = e.target.closest('[data-ajax-cart-close], .show-new-btn');

      // Click inside the open cart and NOT on a close control: keep it open
      // and let inner links/buttons (delete, checkout, "Continue Shopping")
      // behave normally (no preventDefault, no toggle).
      if (insideCart && !onClose) return;

      e.preventDefault();
      $('[data-ajax-cart-trigger]').not(this).removeClass('show-mini-cart');
      $(this).toggleClass('show-mini-cart');
    });

    return true;
  }

  // Run after the cart section's own init has registered its handler
  // (window load is safely after DOMContentLoaded section init).
  function run() {
    if (applyFix()) return;
    var n = 0;
    var t = setInterval(function () {
      n++;
      if (applyFix() || n > 30) clearInterval(t);
    }, 200);
  }

  if (document.readyState === 'complete') {
    run();
  } else {
    window.addEventListener('load', run);
  }
})();
///End Mini cart close behavior

// Start Blog Title Heading Fix
setTimeout(function () {
  const blogTitle = document.querySelector(
    '.heading-wrapper--blog h2.blog__title.title'
  );

  if (blogTitle) {
    const paragraph = document.createElement('p');

    paragraph.className = blogTitle.className;
    paragraph.innerHTML = blogTitle.innerHTML;

    blogTitle.replaceWith(paragraph);
  }
}, 1000);
// End Blog Title Heading Fix

// //Buttons change into div on the home page
// document.querySelectorAll("button.button.button--secondary").forEach(function(button) {
//   const div = document.createElement("div");
//   div.className = button.className;
//   div.innerHTML = button.innerHTML;
//   button.replaceWith(div);
// });
// //End Buttons change into div on the home page

// Start Add Aria Label to Collection Link
const collectionLinks = document.querySelectorAll(
  "a.collection-info__caption-wrapper.collection-info__caption--below-image"
);

collectionLinks.forEach(function (link) {
  const title = link.querySelector(".title");
  const button = link.querySelector(".button.button--secondary");

  if (title && button) {
    const titleText = title.textContent.trim();
    const buttonText = button.textContent.trim();

    link.setAttribute("aria-label", titleText + ", " + buttonText);
  }
});
// End Add Aria Label to Collection Link


// Start Remove Empty H2 on Specific Page
function removeEmptyH2() {
  const page = document.querySelector(
    'body.page.announcement-bar--visible.has-announcement-bar-toggle.swym-ready.swym-buttons-loaded'
  );

  if (!page) return;

  page.querySelectorAll('h2').forEach(function (heading) {
    if (heading.textContent.trim() === '') {
      heading.remove();
    }
  });
}

removeEmptyH2();

const emptyH2Observer = new MutationObserver(function () {
  removeEmptyH2();
});

emptyH2Observer.observe(document.body, {
  childList: true,
  subtree: true
});
// End Remove Empty H2 on Specific Page

// Start Move Focus to Top Back on Popup Close
document.addEventListener("click", function (event) {
  const closeButton = event.target.closest("button.close.popup__close");

  if (!closeButton) return;

  setTimeout(function () {
    const topBack = document.querySelector("div#top-back");

    if (topBack) {
      topBack.setAttribute("tabindex", "-1");
      topBack.focus();
    }
  }, 100);
});
// End Move Focus to Top Back on Popup Close

//AnnouncementBar Fixes
const announcementBar = document.getElementById('announcement-bar');
const closeButton = document.querySelector('.js-close-announcement');

if (announcementBar && closeButton) {
  closeButton.addEventListener('click', function () {
    announcementBar.setAttribute('aria-hidden', 'true');
  });
}
//End AnnouncementBar Fixes

// Start Adding attributes in Add to Cart
setTimeout(function () {
  const addToCartButtons = document.querySelectorAll(
    'button.button.ajax-submit.action_button.button--add-to-cart'
  );

  addToCartButtons.forEach(function (button) {
    button.setAttribute('aria-haspopup', 'dialog');

    const buttonTextElement = button.querySelector('.text');
    const buttonText = buttonTextElement
      ? buttonTextElement.textContent.trim().replace(/\s+/g, ' ')
      : button.textContent.trim().replace(/\s+/g, ' ');

    const heading = button.closest('form')?.querySelector('h1') ||
                    document.querySelector('h1');

    if (heading && buttonText) {
      const headingText = heading.textContent.trim().replace(/\s+/g, ' ');

      button.setAttribute(
        'aria-label',
        `${buttonText} ${headingText}`
      );
    }
  });
}, 2000);
// End Adding attributes in Add to Cart

// Start Desktop Cart Focus Fix
(function () {
  // Desktop only
  if (window.innerWidth <= 768) return;

  let lastTrigger = null;
  let openTimer = null;
  let closeTimer = null;

  // ================= SAVE LAST TRIGGER =================
  document.addEventListener("click", function (event) {
    const headerCart = event.target.closest(
      '.header-cart.action-area__link a.header__link'
    );

    const productButton = event.target.closest(
      'button.button.ajax-submit.action_button.button--add-to-cart'
    );

    if (headerCart) {
      lastTrigger = headerCart;
    } else if (productButton) {
      lastTrigger = productButton;
    } else {
      return;
    }

    clearInterval(openTimer);

    let attempts = 0;

    // ================= WAIT FOR CART TO OPEN =================
    openTimer = setInterval(function () {
      attempts++;

      const cart = document.querySelector(
        '.header-cart.action-area__link.show-mini-cart'
      );

      if (cart) {
        const closeButton = cart.querySelector(
          'button.show-new-btn'
        );

        if (closeButton) {
          clearInterval(openTimer);

          // Focus close button only after drawer is open
          setTimeout(function () {
            if (
              document.contains(closeButton) &&
              cart.classList.contains("show-mini-cart")
            ) {
              closeButton.focus();
            }
          }, 100);

          return;
        }
      }

      if (attempts >= 50) {
        clearInterval(openTimer);
      }
    }, 100);
  }, true);

  // ================= CLOSE BUTTON =================
  document.addEventListener("pointerdown", function (event) {
    const closeButton = event.target.closest(
      '.header-cart.action-area__link button.show-new-btn'
    );

    if (!closeButton || !lastTrigger) return;

    // Save trigger before drawer starts changing
    const triggerElement = lastTrigger;

    clearInterval(closeTimer);

    let attempts = 0;

    // ================= WAIT FOR DRAWER TO CLOSE =================
    closeTimer = setInterval(function () {
      attempts++;

      const cart = document.querySelector(
        '.header-cart.action-area__link'
      );

      if (
        cart &&
        !cart.classList.contains("show-mini-cart")
      ) {
        clearInterval(closeTimer);

        // 300ms delay after drawer closes
        setTimeout(function () {
          if (document.contains(triggerElement)) {
            triggerElement.focus();
          }

          lastTrigger = null;
        }, 300);

        return;
      }

      if (attempts >= 50) {
        clearInterval(closeTimer);
      }
    }, 100);
  }, true);
})();
// End Desktop Cart Focus Fix

// Start Product Gallery Image Count Fix
document.querySelectorAll('.product-gallery__thumbnails').forEach(function (gallery) {
  const thumbnails = gallery.querySelectorAll('.product-gallery__thumbnail');
  const totalImages = thumbnails.length;

  thumbnails.forEach(function (thumbnail, index) {
    const img = thumbnail.querySelector('img');

    if (!img) return;

    const originalAlt = img.getAttribute('alt') || '';

    // Prevent duplicate count
    const cleanAlt = originalAlt.replace(/\s*,?\s*\d+\s+of\s+\d+\s*$/, '');

    img.setAttribute(
      'alt',
      `${cleanAlt}, ${index + 1} of ${totalImages}`
    );
  });
});
// End Product Gallery Image Count Fix

// Start Pagination role
document.querySelectorAll("nav.pagination").forEach(function (pagination) {
  pagination.removeAttribute("role");
});
// End Pagination role

// // Start Product page anchor to p
// var productPage = document.querySelector(
//   "body.product.announcement-bar--visible"
// );

// if (productPage) {
//   productPage.querySelectorAll("a:not([href]):not([role])").forEach(function (link) {
//     var p = document.createElement("p");

//     p.innerHTML = link.innerHTML;
//     link.replaceWith(p);
//   });
// }
// // End Product page anchor to p

//adding aria-hidden="true" on <a> on the needlepoint product page
document.querySelectorAll('.description.content.has-padding-top p').forEach(p => {
  const anchors = p.querySelectorAll('a');

  if (anchors.length < 2) return;

  const firstAnchor = anchors[0];
  const lastAnchor = anchors[anchors.length - 1];

  // Upper/first anchor se title remove karein
  firstAnchor.removeAttribute('title');

  // Last/empty anchor ko hide karein agar us par label/title nahi hai
  if (
    !lastAnchor.hasAttribute('aria-label') &&
    !lastAnchor.hasAttribute('title')
  ) {
    lastAnchor.setAttribute('role', 'presentation');
    lastAnchor.setAttribute('tabindex', '-1');
    lastAnchor.setAttribute('aria-hidden', 'true');
  }
});
//End adding aria-hidden="true" on <a> on the needlepoint product product page

// Start Zoom image accessibility
setTimeout(function () {
  document.querySelectorAll(".zoom-container img.zoomImg").forEach(function (image) {
    image.removeAttribute("alt");
    image.setAttribute("tabindex", "-1");
    image.setAttribute("aria-hidden", "true");
  });
}, 3000);
// End Zoom image accessibility

//handling cart items label
(function () {
  function updateCartItemLabel() {
    var countEl = document.querySelector('[data-bind="itemCount"]');
    var labelEl = document.querySelector('[data-cart-item-label]');

    if (!countEl || !labelEl) return;

    var count = parseInt(countEl.textContent.trim(), 10);

    labelEl.textContent = (count === 0 || count === 1) ? 'item' : 'items';
  }

  updateCartItemLabel();

  var countEl = document.querySelector('[data-bind="itemCount"]');

  if (countEl) {
    var observer = new MutationObserver(updateCartItemLabel);

    observer.observe(countEl, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }
})();
//End handling cart items label


});
